var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83301 9.06348C5.83301 5.19348 8.96301 2.06348 12.833 2.06348C16.703 2.06348 19.833 5.19348 19.833 9.06348C19.833 14.3135 12.833 22.0635 12.833 22.0635C12.833 22.0635 5.83301 14.3135 5.83301 9.06348ZM10.333 9.06348C10.333 10.4435 11.453 11.5635 12.833 11.5635C14.213 11.5635 15.333 10.4435 15.333 9.06348C15.333 7.68348 14.213 6.56348 12.833 6.56348C11.453 6.56348 10.333 7.68348 10.333 9.06348Z",
    fill: "currentColor"
  })));
};
export default SvgLocation;